import api from "@/shared/services/apiClient";

export interface SendingOrgRow {
  code: string;
  descr: string | null;
  active: boolean;
  country_origin: string | null;
  msgnbr: string | null;
  msgset: string | null;
  sort_order: number;
  business_unit: string;
}

export interface SendingOrgDropdownItem {
  value: string;        // = code
  label: string | null; // = descr
  country_origin: string | null;
}

export const sendingOrgService = {
  getAll: async (): Promise<SendingOrgRow[]> => {
    const res = await api.get("/sending-org/list");
    return res.data;
  },

  getDropdown: async (): Promise<SendingOrgDropdownItem[]> => {
    const res = await api.get("/sending-org/dropdown");
    return res.data;
  },

  create: async (data: Omit<SendingOrgRow, "business_unit">) => {
    const res = await api.post("/sending-org/create", data);
    return res.data;
  },

  update: async (code: string, data: Partial<Omit<SendingOrgRow, "code" | "business_unit">>) => {
    const res = await api.put(`/sending-org/update/${code}`, data);
    return res.data;
  },

  delete: async (code: string) => {
    const res = await api.delete(`/sending-org/delete/${code}`);
    return res.data;
  },
};
